import lf from 'lovefield'

export function exo_cubatures (schemaBuilder) {
  schemaBuilder.createTable('exo_cubatures')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.INTEGER)
      .addColumn('exo_chantiers_id', lf.Type.INTEGER)
      .addColumn('const_cubaturestypes_id', lf.Type.STRING)
      .addColumn('kmdebut', lf.Type.NUMBER)
      .addColumn('kmfin', lf.Type.NUMBER)
      .addColumn('description', lf.Type.STRING)
      .addPrimaryKey(['id']) // BC 2019/04 pour pouvoir sauvegarder cette table

      // .addUnique('code', ['code']);
      // .addIndex('id', ['id']);
      // .addIndex('constCubaturestypes_code', ['constCubaturestypes_code']);
      // .addIndex('exoChantiers_id', ['exoChantiers_id']);


}

/*
CREATE TABLE IF NOT EXISTS `exo-cubatures` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(5) NOT NULL,
  `nom` int(11) NOT NULL,
  `exo-chantiers_id` int(11) NOT NULL,
  `const-cubaturestypes_code` varchar(3) NOT NULL,
  `kmdebut` float NOT NULL,
  `kmfin` float NOT NULL,
  `description` text NOT NULL,
  UNIQUE KEY `code` (`code`),
  KEY `id` (`id`),
  KEY `const-cubaturestypes_code` (`const-cubaturestypes_code`),
  KEY `exo-chantiers_id` (`exo-chantiers_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/exoCubatures.schema.js